import { AgentStatus } from "pages/agent-work/definitions";
import { AgentRunHistoryEntry } from "./definitions";

/**
 * Placeholder run history until the backend operation exists. The real
 * endpoint will replace this; see endpoints.ts.
 */
export const MOCK_RUN_HISTORY: AgentRunHistoryEntry[] = [
  {
    runId: "RUN-003",
    status: AgentStatus.WORKING,
    startedAt: "2026-06-24T09:15:00Z",
    updatedAt: "2026-06-24T09:42:00Z",
    triggeredBy: "alias",
  },
  {
    runId: "RUN-002",
    status: AgentStatus.FAILED,
    startedAt: "2026-06-23T14:05:00Z",
    updatedAt: "2026-06-23T14:11:00Z",
    triggeredBy: "alias",
  },
  {
    runId: "RUN-001",
    status: AgentStatus.COMPLETED,
    startedAt: "2026-06-22T11:30:00Z",
    updatedAt: "2026-06-22T12:08:00Z",
    triggeredBy: "alias",
  },
];
